import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './contexts/AuthContext';

const ProviderRoute = ({ children }) => {
    const { isAuth, userType } = useContext(AuthContext);

    return isAuth && userType === 'provider' ? children : <Navigate to="/provider-login" replace />;
};

export default ProviderRoute;
